import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AiReportDisplay = () => {
  const navigate = useNavigate();
  const [reportHtml, setReportHtml] = React.useState('');
  const iframeRef = React.useRef(null);

  React.useEffect(() => {
    // Check sessionStorage first
    const storedHtml = sessionStorage.getItem('aiReportHtml');
    if (storedHtml) {
      setReportHtml(storedHtml);
      sessionStorage.removeItem('aiReportHtml'); // Clean up
    }
  }, []);

  React.useEffect(() => {
    if (reportHtml && iframeRef.current) {
      const blob = new Blob([reportHtml], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      iframeRef.current.src = url;

      return () => URL.revokeObjectURL(url);
    }
  }, [reportHtml]);

  return (
    <div className="min-h-screen w-full relative" style={{
      background: "linear-gradient(135deg, var(--base-200), var(--base-100))",
    }}>
      {/* Top Bar */}
      <div className="fixed top-0 left-0 right-0 z-20 bg-white shadow-md p-4 flex justify-between items-center">
        {window.name !== 'aiReportPopup' && (
          <button onClick={() => navigate(-1)} className="btn btn-sm btn-outline">
            ← Back
          </button>
        )}
        <h1 className="text-xl font-bold">AI Generated Report</h1>
        <div></div>
      </div>

      {/* Blobs */}
      <div className="absolute w-96 h-96 rounded-full blur-3xl opacity-20" style={{ background: "var(--primary)", top: "10%", left: "3%" }} />
      <div className="absolute w-96 h-96 rounded-full blur-3xl opacity-20" style={{ background: "var(--primary-focus)", bottom: "10%", right: "5%" }} />

      <div className="pt-20 p-6 w-full">
        <div className="glass-card">
          {reportHtml ? (
            <iframe
              ref={iframeRef}
              style={{ width: '100%', height: '80vh', border: 'none' }}
              title="AI Report"
            />
          ) : (
            <div className="text-center text-gray-500 py-8">
              No report content available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiReportDisplay;